import { render } from "./BusinessProgress.vue?vue&type=template&id=36df4ecc&scoped=true"
import script from "./BusinessProgress.vue?vue&type=script&lang=js"
export * from "./BusinessProgress.vue?vue&type=script&lang=js"

import "./BusinessProgress.vue?vue&type=style&index=0&id=36df4ecc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36df4ecc"]])

export default __exports__